import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, {
  init,
  submit,
  initPage,
  queryMobilePackage,
  queryMobilePackageList
} from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Data = Loadable({
    loader: () => import('./Data'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topUpDataState: state.topUpDataState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          submit,
          initPage,
          queryMobilePackage,
          languageChange,
          queryMobilePackageList
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/data`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Data {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
